export const NP_DOCUMENT_TITLE_TAG = '<np-document-title/>';

export function countDocumentTitleTags(value: string): number {
  const matches = value
    .replace(/\r\n/g, '\n')
    .match(/^<np-document-title\/>\s*$/gm);
  return matches?.length ?? 0;
}

export function createDefaultMarkdownDocumentValue(): string {
  return `${NP_DOCUMENT_TITLE_TAG}\n\n`;
}

export function prependDocumentTitleTag(value: string): string {
  const normalized = value.replace(/\r\n/g, '\n').trim();
  if (countDocumentTitleTags(normalized) > 0) {
    return normalized.length > 0 ? `${normalized}\n` : normalized;
  }

  return normalized.length > 0
    ? `${NP_DOCUMENT_TITLE_TAG}\n\n${normalized}\n`
    : createDefaultMarkdownDocumentValue();
}

export function getDocumentTitleTagValidationMessage(
  value: string,
): string | null {
  const count = countDocumentTitleTags(value);
  if (count <= 1) return null;

  return 'Only one <np-document-title/> block is supported per markdown document.';
}
